import React, { useState, useRef, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import { logout } from "../features/user/redux/signupSlice";
import { FileText, FolderOpen, User, LogOut, ChevronDown } from "lucide-react";
import "./DashboardHeader.css";
import userStore from "../../zustand/userStore";

export default function DashboardHeader() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.signup);
  const storedUser = user || JSON.parse(localStorage.getItem("userData"));
  const location = useLocation();
  const [profileOpen, setProfileOpen] = useState(false);
  const isDocFormRoute = location.pathname.startsWith("/docFormTestRunNew");
  const dropdownRef = useRef(null);
  const removeUser = userStore.getState().removeUser;

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setProfileOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLogout = () => {
    dispatch(logout());
    removeUser();
    navigate("/home");
  };

  const userName = storedUser?.name || storedUser?.email || "User";
  const initials = userName
    .split(" ")
    .map((n) => n[0])
    .join("")
    .toUpperCase()
    .slice(0, 2);

  return (
    <header className="dash-header">
      <div className="dash-header-inner">
        {/* Logo */}
        <div className="dash-header-logo" onClick={() => navigate("/dashboard")}>
          <img src="/images/docmasterLogo.png" alt="Docmaster" />
        </div>

        {/* Navigation */}
        <nav className="dash-header-nav">
          <NavLink
            to="/"
            end
            className={({ isActive }) =>
              `dash-nav-item ${isActive || isDocFormRoute ? "dash-nav-active" : ""}`
            }
          >
            <FileText size={18} />
            <span>Documents</span>
          </NavLink>
          <NavLink
            to="/myDocForms"
            className={({ isActive }) =>
              `dash-nav-item ${isActive ? "dash-nav-active" : ""}`
            }
          >
            <FolderOpen size={18} />
            <span>My Documents</span>
          </NavLink>
        </nav>

        {/* Profile */}
        <div className="dash-header-profile" ref={dropdownRef}>
          <button
            className="dash-profile-btn"
            onClick={() => setProfileOpen((p) => !p)}
          >
            <div className="dash-avatar">{initials}</div>
            <span className="dash-profile-name">{userName}</span>
            <ChevronDown
              size={16}
              className={`dash-chevron ${profileOpen ? "dash-chevron-open" : ""}`}
            />
          </button>

          {profileOpen && (
            <div className="dash-profile-dropdown">
              <div className="dash-dropdown-header">
                <div className="dash-avatar dash-avatar-lg">{initials}</div>
                <div>
                  <p className="dash-dropdown-name">{userName}</p>
                  <p className="dash-dropdown-email">{storedUser?.email || ""}</p>
                </div>
              </div>
              <div className="dash-dropdown-divider" />
              <button className="dash-dropdown-item" onClick={() => { setProfileOpen(false); }}>
                <User size={16} />
                <span>Profile</span>
              </button>
              <button className="dash-dropdown-item dash-dropdown-logout" onClick={handleLogout}>
                <LogOut size={16} />
                <span>Logout</span>
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}
